import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vfs-no-tx',
  templateUrl: './no-tx.component.html',
  styleUrls: ['./no-tx.component.scss']
})
export class NoTxComponent implements OnInit {
  @Input() condition: boolean;
  @Input() defaultMessage: string;

  constructor(protected translateService: TranslateService) {}

  ngOnInit() {}

  getMessage(): string {
    return this.defaultMessage ? this.defaultMessage : this.translateService.instant('language.noTranslation');
  }
}
